@if (fieldsToGenerate) {
  <form #container
        [ngClass]="{ 'k-form': true, busy: isLoading, panelbarView: isPanelbarView }"
        [formGroup]="formGroup"
        tiObserveVisibility
        [debounceTime]="300"
        [attr.id]="seed"
        (visible)="visible = $event">
    @if (!isPanelbarView && isLegacySectionMode) {
      <div class="simple-form-wrapper">
        <ng-container *ngTemplateOutlet="fieldsTemplate; context: { fields: fieldsToGenerate }" />
        <ng-content />
      </div>
    }

    @if (!isPanelbarView && !isLegacySectionMode) {
      <div [class.sections-content]="isStandalone">
        @for (section of sections; track section) {
          <ti-dynamic-form-section
            [title]="section.title"
            [appearance]="section.appearance"
            [isStandalone]="isStandalone"
            [state]="section?.active ? 'active' : 'default'"
            [collapsed]="sectionState[section.name] ?? false"
            [metadata]="section?.metadata"
            (collapsedChange)="sectionState[section.name] = $event">
            <div class="form-item-list">
              @for (item of collectionMap[section.name]; track item) {
                @if (item.type === 'group') {
                  <ng-container *ngTemplateOutlet="groupTemplate; context: { group: item }" />
                }
                @if (item.type === 'field') {
                  <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: fieldsMap[item.name] }" />
                }
              }
            </div>
          </ti-dynamic-form-section>
        }
      </div>
    }

    @if (isPanelbarView) {
      <kendo-panelbar>
        @for (field of fieldsToGenerate; track field) {
          <kendo-panelbar-item title="{{ field.fieldTitle }}" [expanded]="checkIsPanelExpanded(field)">
            @if (field.facetedSearchField) {
              <ng-template kendoPanelBarItemTitle>
                <span class="field-title">{{ field.fieldTitle }}</span>
                @if (getCountSelectedFacets(field)) {
                  <span class="facets-count-selected">
                    {{ getCountSelectedFacets(field) }}&nbsp;{{ strings.selected }}
                    <span (click)="clearFieldSelectedFacets($event, field)" class="fa fa-times ml-1"></span>
                  </span>
                }
              </ng-template>
            }
            @if (!field.facetedSearchField) {
              <ng-template kendoPanelBarItemTitle>
                <ng-template #tooltip>{{ strings.removeField }}</ng-template>
                <div
                  class="wrap-remove-field"
                  kendoTooltip
                  [tooltipTemplate]="tooltip"
                  filter=".btn-remove-field"
                  [showOn]="'hover'"
                  position="right">
                  <button
                    kendoButton
                    class="btn-remove-field"
                    [iconClass]="'fa fa-trash'"
                    [primary]="true"
                    [look]="'flat'"
                    (click)="removeField($event, field.fieldName)"></button>
                </div>
              </ng-template>
            }

            <ng-template kendoPanelBarContent>
              <a name="{{ seed }}_{{ field.fieldName }}" [title]="field.fieldName"></a>
              @if (field.renderer.component) {
                <ti-renderer [component]="field.renderer.component"
                             [updater]="field.renderer.updater"
                             [data]="field.renderer.data" />
              }
            </ng-template>
          </kendo-panelbar-item>
        }
      </kendo-panelbar>
    }
    <ng-content />
    @if (monitorResize) {
      <kendo-resize-sensor (resize)="onResize()" />
    }
  </form>
}

@if (showValidationErrors && validationErrors?.length) {
  <ti-advanced-validator-list [items]="validationErrors"
                              [hostClass]="'inside-dynamic-form'"
                              [ngStyle]="{ right: tooltipRight + 'px', bottom: tooltipBottom + 'px' }"
                              (close)="validationErrors = []" />
}

@if (isLoading && fieldsToGenerate?.length === 0) {
  <ti-skeleton [fields]="fieldsIncludedInCoding" />
}

<ng-template #fieldsTemplate let-fields="fields">
  @for (field of fields; track field) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field }" />
  }
</ng-template>

<ng-template #fieldTemplate let-field="field">
  <div [class]="'form-item-width-' + (isLegacySectionMode ? 100 : field.width)">
    @if (useFieldsCheckers) {
      <div class="change-control">
        <input [ngModelOptions]="{ standalone: true }"
               [(ngModel)]="selected[getFieldCheckerIndex(field)]"
               type="checkbox"
               class="k-checkbox"
               id="selected_{{ getFieldCheckerIndex(field) }}"
               [title]="field.fieldName" />
        <label class="k-checkbox-label" for="selected_{{ getFieldCheckerIndex(field) }}"></label>
        <span style="display: none">{{ field.fieldName }}</span>
      </div>
    }
    <!-- please check the AdvancedValidatorListComponent before changing this structure -->

    <a name="{{ seed }}_{{ field.fieldName }}" [title]="field.fieldName"></a>
    @if (field?.showInlineDescription && field?.description) {
      <ti-html-content class="instructions" appearance="instructions" [content]="field?.description" />
    }
    <div class="form-control-wrapper">
      <div class="form-control-container">
        @if (field?.renderer?.component) {
          <ti-renderer [component]="field.renderer.component"
                       [updater]="field.renderer.updater"
                       [data]="field.renderer.data" />
        }
      </div>
      @if (isFieldRemovable) {
        <div class="remove-field" [class.remove-field__wide]="field.UIData.isWide">
          <a (click)="removeFieldRequest(field.fieldName)"><span class="fa fa-trash icon"></span></a>
        </div>
      }
    </div>
  </div>

  <!-- -->
</ng-template>

<ng-template #groupTemplate let-group="group">
  @if (collectionMap[group.name]?.length) {
    <div class="group" [class]="'form-item-width-' + group.width">
      @if (group.title) {
        <h4 class="form-group-title">{{ group.title }}</h4>
      }
      <div class="form-item-list">
        @for (item of collectionMap[group.name]; track item) {
          @if (item.type === 'group') {
            <ng-container *ngTemplateOutlet="groupTemplate; context: { group: item }" />
          }
          @if (item.type === 'field') {
            <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: fieldsMap[item.name] }" />
          }
        }
      </div>
    </div>
  }
</ng-template>
